module.exports = __webpack_public_path__ + "static/media/booth-curtain.e0a38ad5.svg";